import { FC } from "react";

import TableProfileEmplooyee from "../../../components/table/employees/TableProfileEmployee";

const ProfileEmployee: FC = () => {
    return (
        <div style={{height: 'calc(100% - 37px)'}}>
            <TableProfileEmplooyee />
        </div>
    );
};

export default ProfileEmployee;